import React, { useState, useEffect } from "react";
import { Table, Tag, Input, Button, Dropdown, Menu, Select } from "antd";
import { MoreOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Layout from "Layout";
import { mixGetV1, mixDelV1 } from "services/mixin";
import { message } from "antd";

const { Option } = Select;

const ProductPage = () => {
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const handleDelete = async (id) => {
    try {
        const res = await mixDelV1(`/api/v1/be/package/${id}`);
        if (res?.status) {
        message.success("Xóa thành công!");
        getList(); // reload danh sách
        } else {
        message.error("Xóa thất bại!");
        }
    } catch (err) {
        console.log("DELETE ERROR ==> ", err);
        message.error("Có lỗi xảy ra!");
    }
    };


  const getList = async () => {
    setLoading(true);
    try {
      const query = `/api/v1/be/packages?page=${page}&limit=${pageSize}&sort[]=position,desc${search ? `&name=${encodeURIComponent(search)}` : ""}`;
      const res = await mixGetV1(query);
      if (res?.status) {
        const items = res.data.items.map((item) => ({
          key: item.id,
          name: item.name,
          price: item.price.toLocaleString() + " VND",
          commission: item.affiliate_commission + "%",
          duration: item.day + " ngày",
          uses: item.number_of_use,
          user: item.turn,
          status: item.is_active === 1 ? "Active" : "Inactive",
          bought: item.order_pay,
          created: item.created_at.substring(0, 10),
        }));

        setListData(items);
        setPage(res.data.current_page);
        setTotal(res.data.total);
      }
    } catch (err) {
      console.log("API ERROR ==> ", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, [page, pageSize, search]);

  const columns = [
    {
      title: "TÊN",
      dataIndex: "name",
      render: (text, record) => (
        <a href={`/goi-dich-vu/chi-tiet/${record.key}`} style={{ color: "#6e6b7b" }}>
          {text}
        </a>
      ),
    },
    {
      title: "GIÁ",
      dataIndex: "price",
    },
    {
      title: "HOA HỒNG",
      dataIndex: "commission",
    },
    {
      title: "THỜI HẠN",
      dataIndex: "duration",
    },
    {
      title: "SỐ LẦN SỬ DỤNG",
      dataIndex: "uses",
    },
    {
      title: "SỐ USER",
      dataIndex: "user",
    },
    {
      title: "TRẠNG THÁI",
      dataIndex: "status",
      render: (v) => <Tag color={v === "Active" ? "green" : "red"}>{v}</Tag>,
    },
    {
      title: "LƯỢT MUA",
      dataIndex: "bought",
    },
    {
      title: "NGÀY TẠO",
      dataIndex: "created",
    },
    {
        title: "Thao tác",
        key: "actions",
        align: "center",
        render: (_, record) => (
        <div className="flex justify-center gap-2">
            <Button type="primary" size="small" className="bg-blue-500">
            <a href={`/goi-dich-vu/chi-tiet/${record.key}`} style={{ color: "#fefefeff" }}>
                  Sửa
                </a>
            </Button>
            <Button danger size="small" onClick={() => handleDelete(record.key)}>
            Xóa
            </Button>
        </div>
        ),
    },
  ];

  return (
    <Layout>
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <Select value={pageSize} onChange={setPageSize} style={{ width: 80 }}>
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>
            <Option value={50}>50</Option>
          </Select>

          <div style={{ display: "flex", gap: 12 }}>
            <Input
              placeholder="Tìm tên"
              prefix={<SearchOutlined />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: 250 }}
            />

            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/goi-dich-vu/add")}>
              Thêm mới
            </Button>
          </div>
        </div>

        <Table
          columns={columns}
          dataSource={listData}
          pagination={{
            pageSize: pageSize,
            current: page,
            total: total,
            onChange: (p) => setPage(p),
            itemRender: (page, type, originalElement) => {
            // luôn hiển thị chữ màu đen cho các trang
            if (type === 'page') {
                return <span style={{ color: '#000' }}>{page}</span>;
            }
            return originalElement;
            }
          }}
          loading={loading}
          bordered
        />
      </div>
    </Layout>
  );
};

export default ProductPage;
